import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plural'
})
export class PluralPipe implements PipeTransform {

  transform(value: any, word: any, pr): any {
    let rule = value > 1 ? pr : "";
    return value +' '+ word +''+rule;
  }

}
